// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_resource_owner.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Any } from "../../../../google/protobuf/any";
import { UserView } from "../../user/v1/user";
import { UserExpandMask } from "../../user/v1/user";
import { User } from "../../user/v1/user";
/**
 * @generated from protobuf message c1.api.app.v1.ListAppResourceOwnersRequest
 */
export interface ListAppResourceOwnersRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string app_id = 3
     */
    appId: string;
    /**
     * @generated from protobuf field: string resource_id = 4
     */
    resourceId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 5
     */
    resourceTypeId: string;
}
/**
 * The ListAppResourceOwnersResponse message contains a list of results and a nextPageToken if applicable
 *
 * @generated from protobuf message c1.api.app.v1.ListAppResourceOwnersResponse
 */
export interface ListAppResourceOwnersResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.user.v1.User list = 1
     */
    list: User[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retreived.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * User IDs of owners that are immutable and cannot be removed by the user.
     * These owners are managed by the system (e.g., connector-sourced) and will be updated automatically.
     *
     * @generated from protobuf field: repeated string immutable_user_ids = 3
     */
    immutableUserIds: string[];
}
/**
 * The request message for listing app resource owner IDs.
 *
 * @generated from protobuf message c1.api.app.v1.ListAppResourceOwnerIDsRequest
 */
export interface ListAppResourceOwnerIDsRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string resource_id = 2
     */
    resourceId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 3
     */
    resourceTypeId: string;
}
/**
 * The response message for listing app resource owners IDs.
 *
 * @generated from protobuf message c1.api.app.v1.ListAppResourceOwnerIDsResponse
 */
export interface ListAppResourceOwnerIDsResponse {
    /**
     * The list of owner IDs for the app resource.
     *
     * @generated from protobuf field: repeated string user_ids = 1
     */
    userIds: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.SetAppResourceOwnersRequest
 */
export interface SetAppResourceOwnersRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string resource_id = 2
     */
    resourceId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 3
     */
    resourceTypeId: string;
    /**
     * @generated from protobuf field: repeated string user_ids = 4
     */
    userIds: string[];
}
/**
 * The empty response message for setting the app resource owners.
 *
 * @generated from protobuf message c1.api.app.v1.SetAppResourceOwnersResponse
 */
export interface SetAppResourceOwnersResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.AddAppResourceOwnerRequest
 */
export interface AddAppResourceOwnerRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string resource_id = 2
     */
    resourceId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 3
     */
    resourceTypeId: string;
    /**
     * @generated from protobuf field: string user_id = 4
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AddAppResourceOwnerResponse
 */
export interface AddAppResourceOwnerResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.RemoveAppResourceOwnerRequest
 */
export interface RemoveAppResourceOwnerRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string resource_id = 2
     */
    resourceId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 3
     */
    resourceTypeId: string;
    /**
     * @generated from protobuf field: string user_id = 4
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.RemoveAppResourceOwnerResponse
 */
export interface RemoveAppResourceOwnerResponse {
}
/**
 * The request message for deleting app resource owners.
 *
 * @generated from protobuf message c1.api.app.v1.DeleteAppResourceOwnersRequest
 */
export interface DeleteAppResourceOwnersRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string resource_id = 2
     */
    resourceId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 3
     */
    resourceTypeId: string;
}
/**
 * the empty response message for deleting app resource owners.
 *
 * @generated from protobuf message c1.api.app.v1.DeleteAppResourceOwnersResponse
 */
export interface DeleteAppResourceOwnersResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.AppResourceOwnerRef
 */
export interface AppResourceOwnerRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppResourceOwnerRefreshRef
 */
export interface AppResourceOwnerRefreshRef {
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppResourceOwnersRequest
 */
export interface SearchAppResourceOwnersRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserExpandMask expand_mask = 3
     */
    expandMask?: UserExpandMask;
    /**
     * @generated from protobuf field: string app_id = 4
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_resource_id = 5
     */
    appResourceId: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppResourceOwnerRef refs = 6
     */
    refs: AppResourceOwnerRef[];
    /**
     * @generated from protobuf field: repeated string user_ids = 7
     */
    userIds: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppResourceOwnersResponse
 */
export interface SearchAppResourceOwnersResponse {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserView list = 1
     */
    list: UserView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class ListAppResourceOwnersRequest$Type extends MessageType<ListAppResourceOwnersRequest> {
    constructor() {
        super("c1.api.app.v1.ListAppResourceOwnersRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ListAppResourceOwnersRequest>): ListAppResourceOwnersRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.appId = "";
        message.resourceId = "";
        message.resourceTypeId = "";
        if (value !== undefined)
            reflectionMergePartial<ListAppResourceOwnersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAppResourceOwnersRequest): ListAppResourceOwnersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string app_id */ 3:
                    message.appId = reader.string();
                    break;
                case /* string resource_id */ 4:
                    message.resourceId = reader.string();
                    break;
                case /* string resource_type_id */ 5:
                    message.resourceTypeId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAppResourceOwnersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string app_id = 3; */
        if (message.appId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appId);
        /* string resource_id = 4; */
        if (message.resourceId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.resourceId);
        /* string resource_type_id = 5; */
        if (message.resourceTypeId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.resourceTypeId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppResourceOwnersRequest
 */
export const ListAppResourceOwnersRequest = new ListAppResourceOwnersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppResourceOwnersResponse$Type extends MessageType<ListAppResourceOwnersResponse> {
    constructor() {
        super("c1.api.app.v1.ListAppResourceOwnersResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => User },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "immutable_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListAppResourceOwnersResponse>): ListAppResourceOwnersResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.immutableUserIds = [];
        if (value !== undefined)
            reflectionMergePartial<ListAppResourceOwnersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAppResourceOwnersResponse): ListAppResourceOwnersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.user.v1.User list */ 1:
                    message.list.push(User.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated string immutable_user_ids */ 3:
                    message.immutableUserIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAppResourceOwnersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.user.v1.User list = 1; */
        for (let i = 0; i < message.list.length; i++)
            User.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated string immutable_user_ids = 3; */
        for (let i = 0; i < message.immutableUserIds.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.immutableUserIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppResourceOwnersResponse
 */
export const ListAppResourceOwnersResponse = new ListAppResourceOwnersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppResourceOwnerIDsRequest$Type extends MessageType<ListAppResourceOwnerIDsRequest> {
    constructor() {
        super("c1.api.app.v1.ListAppResourceOwnerIDsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ListAppResourceOwnerIDsRequest>): ListAppResourceOwnerIDsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.resourceId = "";
        message.resourceTypeId = "";
        if (value !== undefined)
            reflectionMergePartial<ListAppResourceOwnerIDsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAppResourceOwnerIDsRequest): ListAppResourceOwnerIDsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string resource_id */ 2:
                    message.resourceId = reader.string();
                    break;
                case /* string resource_type_id */ 3:
                    message.resourceTypeId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAppResourceOwnerIDsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string resource_id = 2; */
        if (message.resourceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.resourceId);
        /* string resource_type_id = 3; */
        if (message.resourceTypeId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.resourceTypeId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppResourceOwnerIDsRequest
 */
export const ListAppResourceOwnerIDsRequest = new ListAppResourceOwnerIDsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppResourceOwnerIDsResponse$Type extends MessageType<ListAppResourceOwnerIDsResponse> {
    constructor() {
        super("c1.api.app.v1.ListAppResourceOwnerIDsResponse", [
            { no: 1, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListAppResourceOwnerIDsResponse>): ListAppResourceOwnerIDsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userIds = [];
        if (value !== undefined)
            reflectionMergePartial<ListAppResourceOwnerIDsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAppResourceOwnerIDsResponse): ListAppResourceOwnerIDsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string user_ids */ 1:
                    message.userIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAppResourceOwnerIDsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string user_ids = 1; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.userIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppResourceOwnerIDsResponse
 */
export const ListAppResourceOwnerIDsResponse = new ListAppResourceOwnerIDsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetAppResourceOwnersRequest$Type extends MessageType<SetAppResourceOwnersRequest> {
    constructor() {
        super("c1.api.app.v1.SetAppResourceOwnersRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "App_Resource_Owner" } }] } });
    }
    create(value?: PartialMessage<SetAppResourceOwnersRequest>): SetAppResourceOwnersRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.resourceId = "";
        message.resourceTypeId = "";
        message.userIds = [];
        if (value !== undefined)
            reflectionMergePartial<SetAppResourceOwnersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetAppResourceOwnersRequest): SetAppResourceOwnersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string resource_id */ 2:
                    message.resourceId = reader.string();
                    break;
                case /* string resource_type_id */ 3:
                    message.resourceTypeId = reader.string();
                    break;
                case /* repeated string user_ids */ 4:
                    message.userIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetAppResourceOwnersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string resource_id = 2; */
        if (message.resourceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.resourceId);
        /* string resource_type_id = 3; */
        if (message.resourceTypeId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.resourceTypeId);
        /* repeated string user_ids = 4; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.userIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SetAppResourceOwnersRequest
 */
export const SetAppResourceOwnersRequest = new SetAppResourceOwnersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetAppResourceOwnersResponse$Type extends MessageType<SetAppResourceOwnersResponse> {
    constructor() {
        super("c1.api.app.v1.SetAppResourceOwnersResponse", []);
    }
    create(value?: PartialMessage<SetAppResourceOwnersResponse>): SetAppResourceOwnersResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SetAppResourceOwnersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetAppResourceOwnersResponse): SetAppResourceOwnersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetAppResourceOwnersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SetAppResourceOwnersResponse
 */
export const SetAppResourceOwnersResponse = new SetAppResourceOwnersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddAppResourceOwnerRequest$Type extends MessageType<AddAppResourceOwnerRequest> {
    constructor() {
        super("c1.api.app.v1.AddAppResourceOwnerRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AddAppResourceOwnerRequest>): AddAppResourceOwnerRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.resourceId = "";
        message.resourceTypeId = "";
        message.userId = "";
        if (value !== undefined)
            reflectionMergePartial<AddAppResourceOwnerRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AddAppResourceOwnerRequest): AddAppResourceOwnerRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string resource_id */ 2:
                    message.resourceId = reader.string();
                    break;
                case /* string resource_type_id */ 3:
                    message.resourceTypeId = reader.string();
                    break;
                case /* string user_id */ 4:
                    message.userId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AddAppResourceOwnerRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string resource_id = 2; */
        if (message.resourceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.resourceId);
        /* string resource_type_id = 3; */
        if (message.resourceTypeId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.resourceTypeId);
        /* string user_id = 4; */
        if (message.userId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AddAppResourceOwnerRequest
 */
export const AddAppResourceOwnerRequest = new AddAppResourceOwnerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddAppResourceOwnerResponse$Type extends MessageType<AddAppResourceOwnerResponse> {
    constructor() {
        super("c1.api.app.v1.AddAppResourceOwnerResponse", []);
    }
    create(value?: PartialMessage<AddAppResourceOwnerResponse>): AddAppResourceOwnerResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AddAppResourceOwnerResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AddAppResourceOwnerResponse): AddAppResourceOwnerResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AddAppResourceOwnerResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AddAppResourceOwnerResponse
 */
export const AddAppResourceOwnerResponse = new AddAppResourceOwnerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveAppResourceOwnerRequest$Type extends MessageType<RemoveAppResourceOwnerRequest> {
    constructor() {
        super("c1.api.app.v1.RemoveAppResourceOwnerRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<RemoveAppResourceOwnerRequest>): RemoveAppResourceOwnerRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.resourceId = "";
        message.resourceTypeId = "";
        message.userId = "";
        if (value !== undefined)
            reflectionMergePartial<RemoveAppResourceOwnerRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RemoveAppResourceOwnerRequest): RemoveAppResourceOwnerRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string resource_id */ 2:
                    message.resourceId = reader.string();
                    break;
                case /* string resource_type_id */ 3:
                    message.resourceTypeId = reader.string();
                    break;
                case /* string user_id */ 4:
                    message.userId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RemoveAppResourceOwnerRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string resource_id = 2; */
        if (message.resourceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.resourceId);
        /* string resource_type_id = 3; */
        if (message.resourceTypeId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.resourceTypeId);
        /* string user_id = 4; */
        if (message.userId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.RemoveAppResourceOwnerRequest
 */
export const RemoveAppResourceOwnerRequest = new RemoveAppResourceOwnerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveAppResourceOwnerResponse$Type extends MessageType<RemoveAppResourceOwnerResponse> {
    constructor() {
        super("c1.api.app.v1.RemoveAppResourceOwnerResponse", []);
    }
    create(value?: PartialMessage<RemoveAppResourceOwnerResponse>): RemoveAppResourceOwnerResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RemoveAppResourceOwnerResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RemoveAppResourceOwnerResponse): RemoveAppResourceOwnerResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RemoveAppResourceOwnerResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.RemoveAppResourceOwnerResponse
 */
export const RemoveAppResourceOwnerResponse = new RemoveAppResourceOwnerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAppResourceOwnersRequest$Type extends MessageType<DeleteAppResourceOwnersRequest> {
    constructor() {
        super("c1.api.app.v1.DeleteAppResourceOwnersRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<DeleteAppResourceOwnersRequest>): DeleteAppResourceOwnersRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.resourceId = "";
        message.resourceTypeId = "";
        if (value !== undefined)
            reflectionMergePartial<DeleteAppResourceOwnersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteAppResourceOwnersRequest): DeleteAppResourceOwnersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string resource_id */ 2:
                    message.resourceId = reader.string();
                    break;
                case /* string resource_type_id */ 3:
                    message.resourceTypeId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteAppResourceOwnersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string resource_id = 2; */
        if (message.resourceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.resourceId);
        /* string resource_type_id = 3; */
        if (message.resourceTypeId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.resourceTypeId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DeleteAppResourceOwnersRequest
 */
export const DeleteAppResourceOwnersRequest = new DeleteAppResourceOwnersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAppResourceOwnersResponse$Type extends MessageType<DeleteAppResourceOwnersResponse> {
    constructor() {
        super("c1.api.app.v1.DeleteAppResourceOwnersResponse", []);
    }
    create(value?: PartialMessage<DeleteAppResourceOwnersResponse>): DeleteAppResourceOwnersResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteAppResourceOwnersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteAppResourceOwnersResponse): DeleteAppResourceOwnersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteAppResourceOwnersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DeleteAppResourceOwnersResponse
 */
export const DeleteAppResourceOwnersResponse = new DeleteAppResourceOwnersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppResourceOwnerRef$Type extends MessageType<AppResourceOwnerRef> {
    constructor() {
        super("c1.api.app.v1.AppResourceOwnerRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AppResourceOwnerRef>): AppResourceOwnerRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<AppResourceOwnerRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppResourceOwnerRef): AppResourceOwnerRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppResourceOwnerRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppResourceOwnerRef
 */
export const AppResourceOwnerRef = new AppResourceOwnerRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppResourceOwnerRefreshRef$Type extends MessageType<AppResourceOwnerRefreshRef> {
    constructor() {
        super("c1.api.app.v1.AppResourceOwnerRefreshRef", []);
    }
    create(value?: PartialMessage<AppResourceOwnerRefreshRef>): AppResourceOwnerRefreshRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AppResourceOwnerRefreshRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppResourceOwnerRefreshRef): AppResourceOwnerRefreshRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppResourceOwnerRefreshRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppResourceOwnerRefreshRef
 */
export const AppResourceOwnerRefreshRef = new AppResourceOwnerRefreshRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppResourceOwnersRequest$Type extends MessageType<SearchAppResourceOwnersRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppResourceOwnersRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => UserExpandMask },
            { no: 4, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "app_resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppResourceOwnerRef },
            { no: 7, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<SearchAppResourceOwnersRequest>): SearchAppResourceOwnersRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.appId = "";
        message.appResourceId = "";
        message.refs = [];
        message.userIds = [];
        if (value !== undefined)
            reflectionMergePartial<SearchAppResourceOwnersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppResourceOwnersRequest): SearchAppResourceOwnersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.user.v1.UserExpandMask expand_mask */ 3:
                    message.expandMask = UserExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* string app_id */ 4:
                    message.appId = reader.string();
                    break;
                case /* string app_resource_id */ 5:
                    message.appResourceId = reader.string();
                    break;
                case /* repeated c1.api.app.v1.AppResourceOwnerRef refs */ 6:
                    message.refs.push(AppResourceOwnerRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated string user_ids */ 7:
                    message.userIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppResourceOwnersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.user.v1.UserExpandMask expand_mask = 3; */
        if (message.expandMask)
            UserExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string app_id = 4; */
        if (message.appId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appId);
        /* string app_resource_id = 5; */
        if (message.appResourceId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.appResourceId);
        /* repeated c1.api.app.v1.AppResourceOwnerRef refs = 6; */
        for (let i = 0; i < message.refs.length; i++)
            AppResourceOwnerRef.internalBinaryWrite(message.refs[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated string user_ids = 7; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.userIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppResourceOwnersRequest
 */
export const SearchAppResourceOwnersRequest = new SearchAppResourceOwnersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppResourceOwnersResponse$Type extends MessageType<SearchAppResourceOwnersResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppResourceOwnersResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchAppResourceOwnersResponse>): SearchAppResourceOwnersResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchAppResourceOwnersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppResourceOwnersResponse): SearchAppResourceOwnersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.user.v1.UserView list */ 1:
                    message.list.push(UserView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppResourceOwnersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.user.v1.UserView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            UserView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppResourceOwnersResponse
 */
export const SearchAppResourceOwnersResponse = new SearchAppResourceOwnersResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppResourceOwners
 */
export const AppResourceOwners = new ServiceType("c1.api.app.v1.AppResourceOwners", [
    { name: "List", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/resource_types/{resource_type_id}/resource/{resource_id}/owners", query: { page_size: "page_size", page_token: "page_token" }, terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "AppResourceOwners", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }], group: "App Resource Owner", pagination: { type: "TERRAFORM_ENTITY_PAGINATION_TYPE_CURSOR", inputs: [{ name: "pageToken", type: "TERRAFORM_ENTITY_PAGINATION_INPUT_TYPE_CURSOR" }], outputs: { nextCursor: "$.nextPageToken" } } }] } }, I: ListAppResourceOwnersRequest, O: ListAppResourceOwnersResponse },
    { name: "ListOwnerIDs", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/resource_types/{resource_type_id}/resource/{resource_id}/ownerids", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "App_Resource_Owner", optionalExclusion: "OPTIONAL_EXCLUSION_RESOURCE_ONLY" }], group: "App Resource Owner" }] } }, I: ListAppResourceOwnerIDsRequest, O: ListAppResourceOwnerIDsResponse },
    { name: "Set", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "PUT", route: "/api/v1/apps/{app_id}/resource_types/{resource_type_id}/resource/{resource_id}/owners", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "App_Resource_Owner" }], group: "App Resource Owner" }] } }, I: SetAppResourceOwnersRequest, O: SetAppResourceOwnersResponse },
    { name: "Add", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/resource_types/{resource_type_id}/resource/{resource_id}/owners", group: "App Resource Owner" }] } }, I: AddAppResourceOwnerRequest, O: AddAppResourceOwnerResponse },
    { name: "Remove", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/apps/{app_id}/resource_types/{resource_type_id}/resource/{resource_id}/owners", group: "App Resource Owner" }] } }, I: RemoveAppResourceOwnerRequest, O: RemoveAppResourceOwnerResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/apps/{app_id}/resource_types/{resource_type_id}/resource/{resource_id}/ownerids", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "App_Resource_Owner" }], group: "App Resource Owner" }] } }, I: DeleteAppResourceOwnersRequest, O: DeleteAppResourceOwnersResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppResourceOwnersSearch
 */
export const AppResourceOwnersSearch = new ServiceType("c1.api.app.v1.AppResourceOwnersSearch", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppResourceOwnersRequest, O: SearchAppResourceOwnersResponse }
]);
